// A small helper for building DOM: el("button", { class: "x", type: "button" }, "Text").

type Attrs = Record<string, string | number | boolean | undefined>;

export function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  attrs: Attrs = {},
  ...children: (Node | string)[]
): HTMLElementTagNameMap[K] {
  const node = document.createElement(tag);
  for (const [name, value] of Object.entries(attrs)) {
    if (value === undefined || value === false) continue;
    node.setAttribute(name, value === true ? "" : String(value));
  }
  node.append(...children);
  return node;
}

/** rpm from a crank speed in rad/s. */
export function rpmOf(omega: number): number {
  return (omega * 60) / (2 * Math.PI);
}
